import { render } from "./Home.vue?vue&type=template&id=9b918cde&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=9b918cde&scoped=true&lang=css"
import "./Home.vue?vue&type=style&index=1&id=9b918cde&lang=scss&scoped=true"
import "./Home.vue?vue&type=style&index=2&id=9b918cde&lang=css"

import exportComponent from "/Users/vee/Desktop/git/web/bitcoooPcWebsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b918cde"]])

export default __exports__